import axios from 'axios'
import { MessageBox } from 'element-ui'
import store from '../../store'; // 引入你的store实例

// export const Baseurl = localStorage.getItem("DEBUGAPI") ||  "http://47.113.99.197:8880/api/";
export const Baseurl = localStorage.getItem("DEBUGAPI") ||  "https://haihuiselling.com/api/"; // 线上数据

// export const Baseurl =localStorage.getItem('DEBUGAPI') || 'http://39.108.145.227:8880/'
// export const Baseurl =localStorage.getItem('DEBUGAPI') || 'https://www.hyxun.top/api/'
// export const Baseurl = localStorage.getItem("DEBUGAPI") || "http://192.168.1.190:8880/api/";
//  export const Baseurl = localStorage.getItem('DEBUGAPI') || 'http://192.168.1.195:8880/api/' // 本地
//  export const Baseurl = localStorage.getItem('DEBUGAPI') || 'http://192.168.1.20:8889/api/' // 本地
// export const Baseurl = localStorage.getItem("DEBUGAPI") || "http://192.168getOrderDetailsByOrderId.2.103:8880/api/";
// export const Baseurl = localStorage.getItem("DEBUGAPI") || "http://39.108.145.227:8880/";
// export const Baseurl = localStorage.getItem("DEBUGAPI") ||  "https://7mrm50fnper5.xiaomiqiu.com/api/"; // 线上数据

// 白名单：同时发起多个同样的api请求，取消上一个
const apiList = [
	'roleController/selectNextByDepartment',
	'purchaseController/selectItemList',
	'helpController/selectFather',
	'roleController/selectNextInfoByRid',
	'userControllers/selectUserListByCompanyType',
	'logisticsController/getAllBranchCompany',
	'logisticsController/getServicePurchaseList',
	'unknownManageController/selectUnknownManageList',
	'orderController/deleteOrderPurchaseMark',
	'allegroImage/handleImageWhite',
	'allegroImage/updateImageSize'
]
const cancelAPiWhite = apiList.map((item) => Baseurl + item)

export const setCookie = (key, value) => {
	var exp = new Date()
	var expDate = 24 * 60 * 60 * 1000 * 7
	exp.setTime(exp.getTime() + expDate)
	document.cookie =
		key + '=' + escape(value) + ';expires=' + exp.toGMTString()
}
// export const getCookie = (name) => {
//     var arg = name + "=";
//     var alen = arg.length;
//     var clen = document.cookie.length;
//     var i = 0;
//     while (i < clen) {
//         var j = i + alen;
//         if (document.cookie.substring(i, j) == arg) return getCookieVal(j);
//         i = document.cookie.indexOf(" ", i) + 1;
//         if (i == 0) break;
//     }
//     return null;
// }

function getCookieVal(offset) {
	var endstr = document.cookie.indexOf(';', offset)
	if (endstr == -1) endstr = document.cookie.length
	return unescape(document.cookie.substring(offset, endstr))
}
export const delCookie = (name) => {
	var exp = new Date()
	exp.setTime(exp.getTime() - 1)
	var cval = getCookie(name)
	if (cval != null)
		document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString()
}

//动态设置token
axios.interceptors.request.use(
	function(config) {
		//从localStorage中取出存好的token
		var token = localStorage.getItem('token')
		if (token) {
			// config.headers['token'] = token
			config.headers = {
				token: token,
			}
		}
		//处理请求前代码
		return config
	},
	function(error) {
		//一些事情伴随着错误
		return Promise.reject(error)
	}
)

axios.interceptors.response.use((response) => {
	const {
		data: { status, msg },
	} = response
	if (status === '101') {
		MessageBox.alert(msg, '提示', {
			confirmButtonText: '确定',
			callback: (action) => {
                store.commit('loginOut');
				window.location.href = '/#/login'
			},
		})
		return
	}
	return response
})

// 导出面单的请求路径，允许重复请求
const waybillRequstUrls = [
	'sanTaiController/GetSanTaiSingleLabel',        // case 1
    'yunTuController/labelPrint',                    // case 2
    'yanWenController/getYanWenLabel',              // case 3
    'logisticsController/getSanOrderChannelById',   // case 4
    'dsfController/getLabel',                        // case 6
    'yunTuController/labelPrint',                    // case 7
    'taiJiaController/getOrderPrintLabel',          // case 8
    'baDaTongController/freemarkerPrint',           // case 9
    'yunTuController/labelPrint',                    // case 10
    'dsfController/getLabel',                        // case 11
    'imlShippingMethodController/getImlLabal',       // case 14
    'baidian_order/getOrderLable',                   // case 18
    'wanLeaderTypeController/getWanLeaderLabal',    // case 19
    'jiTuTypeController/getPrintUrl',                // case 22
    'udaTypeController/getUdaLabal',                // case 23
    'dealfyController/getWaybill',                  // case 27
    'cainiaoOrderController/getWaybill',            // case 28 & 31
    'aliexpressSemiHostingCollection/getShippingMarkPdf', // case 32 (AE_GLOBAL_JIT)
    'aliexpressLogistics/getPrintinfo',             // case 32 (other)
    'walmartShipping/downloadLabel',                // case 33
    'shangYiTypeController/getOrderLabel',           // case 34
    'xiaoBaoTypeController/getOrderLabel',           // case 35
	"mercadolibre/getWaybill", // case 36
]

//axios
const requestArr = []

export const ajaxPost = (url, params, headers = null) => {
	let option = {
		'Content-Type': 'application/json;charset=UTF-8',
		'X-Requested-With': 'XMLHttpRequest',
		token: localStorage.getItem('token'),
	}
	if (headers) {
		option.responseType = 'blob'
	}
	let axiosInstance = axios.create({
		headers: option,
		transformRequest: [
			function(data) {
				if (data instanceof Array) {
					return JSON.stringify(data)
				}
				var req = Object.assign({}, data)
				return JSON.stringify(req)
			},
		],
		transformResponse: [
			function(data) {
				if (headers) return data
				var data = JSON.parse(data)
				if (data.code == '206') {
					localStorage.removeItem('token')
					window.location.reload()
				} else if (data.status == '800') {
					MessageBox.alert(data.msg, '提示', {
						confirmButtonText: '确定',
						callback: (action) => {
                            store.commit('loginOut');
							window.location.href = '/#/login'
						},
					})
					return
				}
				return data
			},
		],
		validateStatus: function(status, $router) {
			return status >= 200 && status < 300 // 默认的
		},
	})

	axiosInstance.interceptors.request.use((config) => {
		const url = config.url
		const isHasCancelAPiWhite = cancelAPiWhite.includes(url)
		if (isHasCancelAPiWhite) return config
		// 如果联系发送多次请求发不出去，在这后面加includes('xxx')
		const urlIndex = requestArr.findIndex((item) => {
			const isApiPath = waybillRequstUrls.some(path => config.url.includes(path)); // 如果是 apiPaths 中的请求
			return item.url === config.url 
				&& !item.url.includes('/sellerController/selectSellerByRid') 
				&& !item.url.includes('incomeExpenditureDetailsController/selectIncomeExpenditureDetailsPage')
				&& !item.url.includes('/amazonOrderController/batchSyncOrders') // 新增的排除接口
				&& !item.url.includes('purchaseSkuController/update') // 新增的排除接口
				&& !item.url.includes('purchaseSkuController/insert') // 新增的排除接口
				&& !item.url.includes('purchaseSkuController/getByShopAndSkus') // 新增的排除接口
				&& !isApiPath; // 如果是 apiPaths 中的请求，就忽略重复取消逻辑
		});
		if (urlIndex > -1) {
			requestArr[urlIndex].source('取消请求')
		} else {
			requestArr.push({ url })
		}
		const CancelToken = new axios.CancelToken((c) => {
			const urlIndex = requestArr.findIndex(
				(item) => item.url === config.url
			)
			requestArr[urlIndex].source = c
		})
		config.cancelToken = CancelToken
		return config
	})
	axiosInstance.interceptors.response.use((response) => {
		const {
			config,
			data: { status, msg },
		} = response
		if (status === '101') {
			requestArr.length = 0
			MessageBox.alert(msg, '提示', {
				confirmButtonText: '确定',
				callback: () => {
                    store.commit('loginOut');
					window.location.href = '/#/login'
				},
			})
			return
		}
		const urlIndex = requestArr.findIndex((item) => item.url === config.url)
		if (urlIndex > -1) requestArr.splice(urlIndex, 1)
		return response
	}, (error) => {
		if (axios.isCancel(error)) {
			// 请求被取消，不抛出错误
			return new Promise(() => { }); // 返回一个永不 resolve 的 Promise，静默处理
		}
		return Promise.reject(error);
	})
	return axiosInstance.post(url, params)
}
export const ajaxGet = (url, params) => {
	let axiosInstance = axios.create({
		headers: {
			'Content-Type': 'application/json;charset=UTF-8',
			token: localStorage.getItem('token'),
			Accept: 'application/json',
			'X-Requested-With': 'XMLHttpRequest',
		},
		transformRequest: [
			function(data) {
				var req = Object.assign({}, data)
				return JSON.stringify(req)
			},
		],
		transformResponse: [
			function(data) {
				var data = JSON.parse(data)
				if (data.code == '206') {
					localStorage.removeItem('token')

					window.location.reload()
				}
				return data
			},
		],
		validateStatus: function(status, $router) {
			return status >= 200 && status < 300 // 默认的
		},
	})
	return axiosInstance.get(url, params)
}

export function formatDate(date, fmt) {
	//formatDate(毫秒数,返回的时间格式(YYYY-MM-DD hh:mm:ss))
	date = new Date(date)
	if (/(y+)/.test(fmt)) {
		fmt = fmt.replace(
			RegExp.$1,
			(date.getFullYear() + '').substr(4 - RegExp.$1.length)
		)
	}
	let o = {
		'M+': date.getMonth() + 1,
		'd+': date.getDate(),
		'h+': date.getHours(),
		'm+': date.getMinutes(),
		's+': date.getSeconds(),
	}
	for (let k in o) {
		if (new RegExp(`(${k})`).test(fmt)) {
			let str = o[k] + ''
			fmt = fmt.replace(
				RegExp.$1,
				RegExp.$1.length === 1 ? str : padLeftZero(str)
			)
		}
	}

	return fmt
}

function padLeftZero(str) {
	return ('00' + str).substr(str.length)
}

export function GetQueryString(name) {
	var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
	var r = window.location.search.substr(1).match(reg)
	if (r != null) {
		return unescape(r[2])
	} else {
		return null
	}
}
